import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// Gộp class Tailwind, xử lý trùng lặp/ghi đè — dùng chung cho các component shadcn-vue.
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
